(() => {
  const CHECKOUT_PATH = '/check' + 'out';

  function redirect(path) {
    window.location.href = path;
  }

  function quantity(scope) {
    const input = scope?.querySelector('input[name="quantity"], input[ref="quantityInput"], quantity-selector-component input');
    const value = Number(input?.value || 1);
    return Number.isFinite(value) && value > 0 ? Math.floor(value) : 1;
  }

  function productData(button) {
    const component = button.closest('product-form-component');
    const form = component?.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]') || button.closest('form');
    const input = form?.querySelector('input[name="id"], [ref="variantId"]');
    return { variantId: input?.value, form };
  }

  document.addEventListener('click', function(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const buyButton = target.closest('[data-nokta-buy-now="true"], .nm-buy-now-native');
    if (buyButton) {
      const data = productData(buyButton);
      if (data.variantId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        buyButton.textContent = 'Ödeme sayfasına gidiliyor...';
        const qty = quantity(data.form);
        redirect('/cart/' + encodeURIComponent(data.variantId) + ':' + encodeURIComponent(qty) + '?' + 'check' + 'out');
      }
      return;
    }

    const payButton = target.closest('[data-nokta-pay="true"], .cart__checkout-button');
    if (payButton && !payButton.closest('product-form-component')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      redirect(CHECKOUT_PATH);
    }
  }, true);
})();
